import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import globalFaviconManager from './utils/globalFavicon';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import VirtualAgent from './components/VirtualAgent';
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Support from './pages/Support';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dynamics365Implementation from './pages/Dynamics365Implementation';
import PowerPlatformDevelopment from './pages/PowerPlatformDevelopment';
import PowerAutomate from './pages/PowerAutomate';
import PowerAppsCanvasApp from './pages/PowerAppsCanvasApp';
import Sales from './pages/Sales';
import MicrosoftSolutions from './pages/MicrosoftSolutions';
import DataMigrationIntegration from './pages/DataMigrationIntegration';
import CloudServices from './pages/CloudServices';
import Training from './pages/Training';
import ConsultingServices from './pages/ConsultingServices';
import ProfessionalTraining from './pages/ProfessionalTraining';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import AddOns from './pages/AddOns'; // Temporarily hidden
import CreateBlog from './pages/CreateBlog';
import CreateCaseStudy from './pages/CreateCaseStudy';
import EditBlog from './pages/EditBlog';
import CrmonceRoute from './components/auth/CrmonceRoute';


function App() {
  // Initialize global favicon manager
  useEffect(() => {
    globalFaviconManager.init();
    
    return () => {
      globalFaviconManager.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="header-offset">
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/features" element={<Features />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/support" element={<Support />} />
              <Route path="/help" element={<Support />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dynamics365-implementation" element={<Dynamics365Implementation />} />
              <Route path="/power-platform-development" element={<PowerPlatformDevelopment />} />
              <Route path="/power-platform" element={<PowerPlatformDevelopment />} />
              <Route path="/power-automate" element={<PowerAutomate />} />
              <Route path="/power-apps-canvas-app" element={<PowerAppsCanvasApp />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/microsoft-365" element={<MicrosoftSolutions />} />
              <Route path="/dynamics-365" element={<MicrosoftSolutions />} />
              <Route path="/data-migration-integration" element={<DataMigrationIntegration />} />
              <Route path="/cloud-services" element={<CloudServices />} />
              <Route path="/consulting-services" element={<ConsultingServices />} />
              <Route path="/consulting" element={<ConsultingServices />} />
              <Route path="/professional-training" element={<ProfessionalTraining />} />
              <Route path="/training" element={<Training />} />
              <Route path="/live-training" element={<Training />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              {/* <Route path="/add-ons" element={<AddOns />} /> // Temporarily hidden */}
              <Route path="/create-blog" element={<CrmonceRoute><CreateBlog /></CrmonceRoute>} />
              <Route path="/create-case-study" element={<CrmonceRoute><CreateCaseStudy /></CrmonceRoute>} />
              <Route path="/edit-blog/:slug" element={<CrmonceRoute><EditBlog /></CrmonceRoute>} />
            </Routes>
          </main>
          <Footer />
          <VirtualAgent />
        </div>
      </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App; 